module.exports = __webpack_public_path__ + "img/down-lite.4a7b13bb.png";